var en = {

}

export default en